import { FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import productsData from "../Data/products.json"; // Import products for categories

export function Footer() {
  // Generate hash links exactly as on ProductsPage
  function getCategoryHash(name) {
    return "#" + encodeURIComponent(name.replace(/\s+/g, '').toLowerCase());
  }

  // Extract product categories
  const categories = Array.isArray(productsData?.products)
    ? productsData.products
    : [];

  // Theme colors
  const gold = "#fdca00";
  const blue = "#0393da";

  return (
    <>
      <section
        className="py-10"
        style={{ background: "#e6f6fd" }} // subtle blue-tinted background
      >
        <div className="max-w-7xl mx-auto  px-6">
          <h2 className="text-4xl md:text-5xl flex gap-2 font-semibold mb-4 font-serif">
            <img
              src="/logo.png"
              alt="Western Drymix Logo"
              className="h-12 mb-2"
            />
            <span style={{ color: gold }}>Western Drymix</span>
          </h2>
          <div className="text-gray-800 text-sm leading-relaxed space-y-2 max-w-4xl">
            <p
              className="italic text-xl font-medium"
              style={{ color: blue }}
            >
              Quality is not an act, it’s a habit. Excellence is built daily.
            </p>
            <p>
              At Western Drymix, we specialize in high-quality drymix solutions designed for modern construction needs. Our website showcases our innovative products, industry expertise, and commitment to excellence.
            </p>
            {/* --- ISO & ISI Certification -- */}
            <div className="flex flex-wrap items-center gap-x-6 gap-y-1 mt-3">
              <span className="inline-block bg-[#fdca00]/20 px-3 py-1 rounded font-semibold text-xs text-[#0393da] border border-[#fdca00]">
                ISO 9001:2015
              </span>
              <span className="inline-block bg-[#fdca00]/20 px-3 py-1 rounded font-semibold text-xs text-[#0393da] border border-[#fdca00]">
                ISO 14001:2015
              </span>
              <span className="inline-block bg-[#fdca00]/20 px-3 py-1 rounded font-semibold text-xs text-[#0393da] border border-[#fdca00]">
                ISO 45001:2018
              </span>
              <span className="inline-block bg-green-100/60 px-3 py-1 rounded font-semibold text-xs text-green-800 border border-green-500 ml-2">
                <span className="mr-1">ISI Mark</span>
                <span className="font-mono">IS 15477:2019</span>
              </span>
            </div>
            <div className="text-xs mt-2 text-[#087528] font-medium">
              Approved by Indian Standard (ISI Certified under Tile Adhesive: IS 15477:2019)
            </div>
          </div>
        </div>
      </section>

      <footer
        className="text-white"
        style={{
          background: blue,
        }}
      >
        <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Left: About Us */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo.png"
                alt="Western Drymix Logo"
                className="h-10"
              />
              <span
                className="font-bold text-xl font-serif"
                style={{ color: gold }}
              >
                Western Drymix
              </span>
            </div>
            <h3
              className="font-semibold text-lg mb-4 font-serif"
              style={{ color: gold }}
            >
              About Us
            </h3>
            <p className="text-sm mb-6 text-white/80">
              Western Drymix is dedicated to delivering superior drymix solutions with a focus on quality, consistency, and customer satisfaction.
            </p>
            {/* ISO & ISI Certification in About section */}
            <div className="space-y-1 text-xs mb-4 text-white">
              <div>
                <span className="font-semibold" style={{ color: gold }}>
                  Certifications:
                </span>
                <ul className="list-disc pl-5 mt-1 space-y-0.5">
                  <li>
                    <span className="font-mono">ISO 9001:2015</span>
                  </li>
                  <li>
                    <span className="font-mono">ISO 14001:2015</span>
                  </li>
                  <li>
                    <span className="font-mono">ISO 45001:2018</span>
                  </li>
                  <li>
                    <span className="font-mono">IS 15477:2019</span>{" "}
                    <span className="text-green-200 font-normal">(ISI under Tile Adhesive)</span>
                  </li>
                </ul>
                <div className="mt-1 text-[#c6ffd2]">
                  <span className="font-semibold" style={{ color: gold }}>
                    Approved by Indian Standard
                  </span>
                  <span> (ISI Certified under Tile Adhesive: IS 15477:2019)</span>
                </div>
              </div>
            </div>
            {/* Contact Details: GST, Call, Mail */}
            <div className="space-y-2 text-xs mb-3 text-white/90">
              <div className="flex items-center gap-2">
                <span className="font-semibold" style={{ color: gold }}>
                  GST No.:
                </span>
                <span className="font-mono">08AWEPV4114A1ZU</span>
              </div>
              <div className="flex items-center gap-2">
                <FiPhone className="text-base" />
                <span className="font-semibold" style={{ color: gold }}>
                  Call Us:
                </span>
                <a
                  href="tel:+919257028601"
                  className="underline"
                  style={{ color: "inherit" }}
                >
                  +91-9257028601
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FiMail className="text-base" />
                <span className="font-semibold" style={{ color: gold }}>
                  Email:
                </span>
                <a
                  href="mailto:Westerndrymix@gmail.com"
                  className="underline"
                  style={{ color: "inherit" }}
                >
                  Westerndrymix@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FiMail className="text-base" />
                <span className="font-semibold" style={{ color: gold }}>
                  Email:
                </span>
                <a
                  href="mailto:info@westerndrymix.com"
                  className="underline"
                  style={{ color: "inherit" }}
                >
                  info@westerndrymix.com
                </a>
              </div>
         
            </div>
       
            {/* <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-white hover:text-[#fdca00] transition"
              >
                <FaFacebookF size={20} />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-white hover:text-[#fdca00] transition"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-white hover:text-[#fdca00] transition"
              >
                <FaLinkedinIn size={20} />
              </a>
              <a
                href="https://www.twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="text-white hover:text-[#fdca00] transition"
              >
                <FaTwitter size={20} />
              </a>
            </div> */}
          </div>

          {/* Middle: Quick Links */}
          <div className="flex flex-col mx-auto">
            <h3
              className="font-semibold text-lg mb-4 font-serif"
              style={{ color: gold }}
            >
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="/"
                  className="hover:underline cursor-pointer hover:text-[#fdca00] transition"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="hover:underline cursor-pointer hover:text-[#fdca00] transition"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/products"
                  className="hover:underline cursor-pointer hover:text-[#fdca00] transition"
                >
                  Products
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="hover:underline cursor-pointer hover:text-[#fdca00] transition"
                >
                  Contact Us
                </a>
              </li>
            </ul>
       
          </div>

          {/* New: Product Categories Links */}
          <div className="flex flex-col mx-auto">
            <h3
              className="font-semibold text-lg mb-4 font-serif"
              style={{ color: gold }}
            >
              Product Categories
            </h3>
            <ul className="space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.categoryId}>
                  <a
                    href={`/products/${getCategoryHash(cat.categoryName)}`}
                    className="hover:underline transition"
                    style={{
                      color: "inherit",
                      transition: "color 0.15s",
                    }}
                    onMouseOver={e => (e.currentTarget.style.color = gold)}
                    onMouseOut={e => (e.currentTarget.style.color = "inherit")}
                  >
                    {cat.categoryName}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Location */}
          <div className="flex flex-col  mx-auto">
            <h3
              className="font-semibold text-lg mb-4 font-serif"
              style={{ color: gold }}
            >
              Location
            </h3>
            <div>
              <span className="font-semibold" style={{ color: gold }}>Address:</span> Western Drymix<br />
              Plot No -205, Near Rathi Chowk, matsya industrial area,<br />
              Alwar Rajasthan 301030
            </div>
       
            <span className="text-xs text-white/80 pt-2">
              Available Daily: 7am - 10pm
            </span>
          </div>
        </div>
        <div
          className="border-t py-3 px-6"
          style={{
            borderColor: "rgba(255,255,255,0.16)",
            background: gold,
            color: blue,
          }}
        >
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center justify-between gap-2 text-xs md:text-sm text-center md:text-left">
            <span>
              &copy; 2024 Western Drymix Pvt. Ltd. All rights reserved.
            </span>
            <span className="flex items-center justify-center gap-2 mt-2 md:mt-0">
              Tech Partner &ndash;{" "}
              <a
                href="https://gowappily.in"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold underline hover:text-black transition"
                style={{ color: blue }}
              >
                GoWappily Infotech
              </a>
            </span>
            {/* <div className="flex items-center justify-center gap-5 mt-2 md:mt-0">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-[#0393da] hover:text-black transition"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-[#0393da] hover:text-black transition"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-[#0393da] hover:text-black transition"
              >
                <FaLinkedinIn size={18} />
              </a>
              <a
                href="https://www.twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="text-[#0393da] hover:text-black transition"
              >
                <FaTwitter size={18} />
              </a>
            </div> */}
          </div>
        </div>
      </footer>
    </>
  );
}
